// we do not extend the built in error if ever the code is transpiled
// by babel as es5 limitations do not allow it https://babeljs.io/docs/en/caveats#classes
export const parseError = (message, location) => {
    const error = (new Error(message));
    error.rcBibParser = { location };
    return error;
};
export const isParseError = (e) => e.hasOwnProperty('rcBibParser');
